module.exports = __webpack_public_path__ + "img/3.2a7cc453.jpg";